/** Раздел «Маркетплейс сайтов»: шаблоны (товары магазина), клиенты и оплаты, сайты клиентов. Только администраторы. */
export const initMarketplaceSitesRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/marketplace/templates",
          name: "marketplace-templates",
          component: () => import("@/pages/manage/marketplace-sites/templates.vue"),
          meta: { requiresAuth: true, roles: [config.roles.administrators] },
        },
        {
          path: "/manage/marketplace/clients",
          name: "marketplace-clients",
          component: () => import("@/pages/manage/marketplace-sites/clients.vue"),
          meta: { requiresAuth: true, roles: [config.roles.administrators] },
        },
        {
          path: "/manage/marketplace/sites",
          name: "marketplace-sites",
          component: () => import("@/pages/manage/marketplace-sites/sites.vue"),
          meta: { requiresAuth: true, roles: [config.roles.administrators] },
        },
      ];
